import React from "react";
import AdditionalExpertForm from "./additionalExpertForm";
export default function AdditionalExpertSignup({ handleAdditionalSignup }) {
  return (
    <div className="create-account">
      <div className="content">
        <div className="">
          <div className="col-12">
            <h2>Complete your Expert profile</h2>
            <p>
              Please add your professional details so we can connect
              <br /> you with the right patients
            </p>
            <AdditionalExpertForm
              handleAdditionalSignup={handleAdditionalSignup}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
